import * as Yup from 'yup';

const validateEditCarModal = Yup.object().shape({
  description: Yup.string().nullable().required(`Обов'язкове поле`),
  transport: Yup.object().shape({
    licensePlate: Yup.string().nullable().required(`Обов'язкове поле`),
  }),
});

export default validateEditCarModal;
